/** 병원 포트폴리오 스크린샷 — public/portfolio/hospital/ */

function hospitalSrc(filename) {
  return `/portfolio/hospital/${filename}`;
}

export const HOSPITAL_PORTFOLIO_IMAGES = [
  {
    id: "orthopedic",
    title: "정형외과",
    url: "orthopedic.dsite",
    src: hospitalSrc("orthopedic.webp"),
  },
  {
    id: "general",
    title: "종합병원",
    url: "general-hospital.dsite",
    src: hospitalSrc("gimpo-woori-hospital.webp"),
  },
  {
    id: "internal",
    title: "내과",
    url: "internal-medicine.dsite",
    src: hospitalSrc("internal-medicine.webp"),
  },
  {
    id: "obgyn",
    title: "산부인과",
    url: "obgyn-clinic.dsite",
    src: hospitalSrc("obgyn.webp"),
  },
  {
    id: "plastic",
    title: "성형외과",
    url: "plastic-surgery.dsite",
    src: hospitalSrc("plastic-surgery.webp"),
  },
  {
    id: "skin-food",
    title: "스킨푸드",
    url: "skinfood-clinic.dsite",
    src: hospitalSrc("skinfood.webp"),
  },
  {
    id: "pediatric",
    title: "소아과",
    url: "momhand-pediatric.dsite",
    src: hospitalSrc("momhand-pediatric.webp"),
  },
  {
    id: "dental",
    title: "치과",
    url: "dental-clinic.dsite",
    src: hospitalSrc("dental.webp"),
  },
  {
    id: "dermatology",
    title: "피부과",
    url: "dermatology.dsite",
    src: hospitalSrc("dermatology.webp"),
  },
];

export const DEFAULT_HOSPITAL_IMAGE = HOSPITAL_PORTFOLIO_IMAGES[0];
